import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["content"];
// These fields are seeded from the staged page by useStagedPageReduxSync.
// When stagedPage.seeded is true, FETCH_CONTENT_SCHEMA_SUCCEEDED (combined-edit-data)
// must not overwrite them with the live page's values.
const STAGED_PAGE_SEEDED_FIELDS = ['slug', 'name', 'htmlTitle', 'domain'];

// eslint-disable-next-line @typescript-eslint/no-explicit-any

// eslint-disable-next-line @typescript-eslint/no-explicit-any

const stagedPageSettingsMiddleware = ({
  getState
}) => next => action => {
  var _action$response, _getState$stagedPage;
  if (action.type === 'FETCH_CONTENT_SCHEMA_SUCCEEDED' && (_action$response = action.response) !== null && _action$response !== void 0 && _action$response.content && (_getState$stagedPage = getState().stagedPage) !== null && _getState$stagedPage !== void 0 && _getState$stagedPage.seeded) {
    const state = getState();
    const _action$response2 = action.response,
      {
        content
      } = _action$response2,
      restResponse = _objectWithoutPropertiesLoose(_action$response2, _excluded);
    const strippedContent = Object.assign({}, content);
    for (const field of STAGED_PAGE_SEEDED_FIELDS) {
      var _state$contentModel$g, _state$contentModel, _state$contentModel$g2, _state$contentModel2, _state$contentModel3;
      const seededValue = (_state$contentModel$g = (_state$contentModel = state.contentModel) === null || _state$contentModel === void 0 || (_state$contentModel$g2 = (_state$contentModel2 = _state$contentModel).get) === null || _state$contentModel$g2 === void 0 ? void 0 : _state$contentModel$g2.call(_state$contentModel2, field)) !== null && _state$contentModel$g !== void 0 ? _state$contentModel$g : (_state$contentModel3 = state.contentModel) === null || _state$contentModel3 === void 0 ? void 0 : _state$contentModel3[field];
      if (seededValue !== undefined) {
        strippedContent[field] = seededValue;
      } else {
        delete strippedContent[field];
      }
    }
    return next(Object.assign({}, action, {
      response: Object.assign({}, restResponse, {
        content: strippedContent
      })
    }));
  }
  return next(action);
};
export default stagedPageSettingsMiddleware;